<template>
    <div class="row">
        <div class="col-md-6">
            <div class="card section-item-order-data-container p-0 text-center lift mb-2" style="background-color: #8b8b8b ;cursor:pointer;color:white;padding-bottom: 2px !important">
                <label class="btn btn-primary btn-file-upload m-0" id="inputFile" style="margin:auto;background-color: #8b8b8b;font-weight: 500;padding-top: 10px;">
                    Sub&iacute; tus archivos <i class="fa-solid fa-upload"></i>
                    <input type="file" multiple id="fileInput" ref="fileInput" @change="this.handleFileChange" accept="application/pdf, image/jpeg, image/png" /> <br>
                    <a style="font-size: 15px;font-weight:400;">No te olvides de sumarlos al carrito.</a>
                </label>
            </div>
        </div>
        <div class="col-md-3">
            <button class="card section-item-order-data-container lift p-0 mb-2 w-100" style="background-color: #0A6ACB;cursor:pointer;" @click="this.addtoOrder()">
                <div class="col-md-12 text-center mt-1" style="color:white;font-size: 20px;  font-weight: 500;">
                    Subtotal: 
                    <label v-if="this.totalSubOrder() != 0 && this.optionPrint === 'IG' && this.hoja.length>1 && this.cantidad>0 &&  this.formato.length>1 && this.calidad.length>1 && this.faz.length>1 && this.tipoPapel.length>1 && this.terminado.length>1"> 
                        {{this.totalSubOrder()}}
                    </label> 
                    <label v-else-if="this.totalSubOrder() != 0 && this.optionPrint === 'F' && this.hoja.length>1 && this.cantidad>0 &&  this.formato.length>1 && this.calidad.length>1 && this.margen.length>1 && this.tipoPapel.length>1"> 
                        {{this.totalSubOrder()}}
                    </label> 
                    <label v-else> $0</label>
                    <br>
                    <label class="btn btn-pay" style="background-color: #0A6ACB;color:white">
                        Añadir <i class="fa-solid fa-cart-plus"></i>
                    </label>
                </div>
            </button>
        </div>
        <div class="col-md-3">
            <div class="card section-item-order-data-container lift p-0 mb-2" style="background-color: #95c123;cursor:pointer;" @click="this.previewOrder()">
                <div class="col-md-12 text-center mt-1" style="color:white;font-size: 20px;  font-weight: 500;">
                    Total: <label v-if="this.totalOrder() != 0"> {{this.totalOrder()}}</label> <label v-else> $0</label> <br>
                    <label class="btn btn-pay">
                        Pagar <i class="fa-solid fa-credit-card"></i>
                    </label>
                </div>
            </div>
        </div>
    </div>
    
    <div class="section-item-file-data-container" style="margin-top:25px;min-height:553px;background-color: inherit;">
        <div class="row">
            <!-- Archivos subiendo -->
            <div v-for="item in this.uploadingFiles" :key="item.tempId" class="col-md-4 mt-4 text-center">
                <div class="card" style="min-height: 330px;">
                    <div class="d-flex flex-column justify-content-center align-items-center h-100 px-3" style="min-height: 280px;">
                        <i class="fa-solid fa-file-arrow-up mb-3" style="font-size: 40px; color: #0A6ACB; opacity: 0.7;"></i>
                        <p class="mb-1" style="font-size: 13px; font-weight: 500; color: #555; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            {{ item.name }}
                        </p>
                        <div class="w-75 mt-3">
                            <div style="background: #e9ecef; border-radius: 10px; height: 8px; overflow: hidden;">
                                <div
                                    :style="{
                                        width: item.progress + '%',
                                        background: item.progress < 100 ? '#0A6ACB' : '#95c123',
                                        height: '100%',
                                        borderRadius: '10px',
                                        transition: 'width 0.3s ease'
                                    }"
                                ></div>
                            </div>
                            <small class="d-block mt-2" style="font-size: 11px; color: #888;">
                                <span v-if="item.progress < 100">
                                    <i class="fa-solid fa-cloud-arrow-up me-1"></i>Subiendo... {{ item.progress }}%
                                </span>
                                <span v-else>
                                    <i class="fa-solid fa-spinner fa-spin me-1"></i>Cotizando precio...
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="data in this.pdfSrc" :key="data" class="col-md-4 mt-4 text-center">
                <div class="card">
                    <div class="row justify-content-center pdf-height">
                        <div class="col-md-12 text-center">
                            <label class="mt-2 price-file w-100" v-if="this.optionPrint === 'IG' && this.hoja.length>1 && this.cantidad>0 &&  this.formato.length>1 && this.calidad.length>1 && this.faz.length>1 && this.tipoPapel.length>1 && this.terminado.length>1">Precio {{this.formatearMoneda(data.price * this.cantidad) }}</label>
                            <label class="mt-2 price-file w-100" v-else-if="this.optionPrint === 'F' && this.hoja.length>1 && this.cantidad>0 &&  this.formato.length>1 && this.calidad.length>1 && this.tipoPapel.length>1 && this.margen.length>1">Precio {{this.formatearMoneda(data.price * this.cantidad) }}</label>
                            <label class="mt-2 price-file w-100" v-else>Sin cotizar</label>
                            <hr class="mt-2 mb-0">
                        </div>
    
                        <!-- formato 1 x carilla -->
                        <div class="col-md-12 mb-3" v-if="formato == 'FH01'">
                            <div class="container-pdf pdf-page">
                                <pdfvuer v-if="this.optionPrint === 'IG'" ref="pdfViewer1" :src="this.createPDF(data)" :page="page1" />
                                <img v-else :src="this.createPDF(data)" class="img-fluid" style="max-height: 300px; object-fit: contain;" /> 
                            </div>
                        </div>
                        <!-- formato 2 x carilla horizontal-->
                        <div class="col-md-12 mb-3" v-if="formato == 'FH02'">
                            <div class="pdf-container pdf-flex">
                                <div class="pdf-page">
                                    <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page1" />
                                </div>
                                <div class="pdf-page">
                                    <pdfvuer ref="pdfViewer1"  v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page2" />
                                </div>
                            </div>
                        </div>
                        <!-- formato 2 x carilla vertical-->
                        <div class="col-md-12 mb-3" v-if="formato == 'FH04'">
                            <div class="container-pdf pdf-page-vertical">
                                <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page1" />
                                <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page2" />
                            </div>
                        </div>
    
                        <div class="col-md-12 mb-3" v-if="formato == 'FH03'">
                            <div class="pdf-container pdf-flex justify-content-center">
                                <div class="pdf-page-vertical">
                                    <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page1" />
                                </div>
                                <div class="pdf-page-vertical">
                                    <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page2" />
                                </div>
                            </div>
                            <div class="pdf-container pdf-flex justify-content-center">
                                <div class="pdf-page-vertical">
                                    <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page3" />
                                </div>
                                <div class="pdf-page-vertical">
                                    <pdfvuer ref="pdfViewer1" v-if="this.optionPrint === 'IG'" :src="this.createPDF(data)" :page="page4" />
                                </div>
                            </div>
                        </div>
    
                    </div>
                    <div class="col-md-12 pb-2">
                        <label class="price-file w-100">P&aacute;ginas: {{ data.pages }}</label>
                    </div>
                </div>
                <div class="col-md-12">
                    <a class="btn btn-primary btn-file-upload mt-2 lift mb-1  icon-pdf-view" @click="previewPdf(data)">
                        <i class="fa-solid fa-eye"></i>
                    </a>
                    <a class="btn btn-primary btn-file-upload mt-2 lift mb-1 ms-2 icon-pdf-trash" @click="removeFileCotizacion(data)">
                        <i class="fa-solid fa-trash"></i>
                    </a>
                </div>
            </div>
    
            <ModalPdf :pdfPreview="pdfPreview" v-if="this.isVisible" />
            <ModalOrder @removeItemOrder="removeOrder" :order="order" v-if="this.isVisibleOrder" />
    
        </div>
    </div>
    </template>
    
    <script>
    import ModalPdf from '../ModalPdf.vue'
    import ModalOrder from '../ModalOrder.vue'
    import pdfvuer from 'pdfvuer';
    import { isValidEmail } from '@/utils/emailValidation';
    import tioTotoService from '../../service/data.service';
    import store from '@/store/index.js';
    import * as pdfjsLib from "pdfjs-dist/webpack";
    import AWS from 'aws-sdk/global';
    import S3 from 'aws-sdk/clients/s3';
    pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;
    
    require('dotenv').config();
    
    export default {
        name: 'file',
        components: {
            ModalPdf,
            pdfvuer,
            ModalOrder
        },
        data() {
            return {
                pdfSrc: [],
                order: [],
                pdfPreview: "",
                isVisible: true,
                isVisibleOrder: true,
                page1: 1,
                page2: 2,
                page3: 3,
                page4: 4,
                uploadingFiles: []
            };
        },
        methods: {
            clearPdfFiles() {
                this.pdfSrc = [];
            },
            handleFileChange: async function (event) {
                try {
                    this.validationDataUser();
                    if (this.validatePdfReload()) {
                        const filePromises = Array.from(event.target.files).map(file => this.uploadFileS3(file));
                        await Promise.all(filePromises);
                    } else {
                        this.clearInputFile();
                        this.$swal("Tío Toto", "Para cotizar un archivo es necesario completar la forma de impresión.", "info");
                    }
                } catch (e) {
                    this.clearInputFile();
                    this.$swal("Tío Toto", e, "info");
                }
            },
            validationDataUser(){
                const errors = {};
                const empty = (v) => v == null || String(v).trim() === "";
                const emailTrim = this.email != null ? String(this.email).trim() : "";
                const confirmTrim = this.emailConfirmation != null ? String(this.emailConfirmation).trim() : "";

                if (empty(this.name)) errors.name = "Requerido";
                if (empty(this.lastName)) errors.lastName = "Requerido";
                if (empty(this.phone)) errors.phone = "Requerido";

                if (empty(this.email)) {
                    errors.email = "Requerido";
                } else if (!isValidEmail(emailTrim)) {
                    errors.email = "Email inválido";
                }

                if (empty(this.emailConfirmation)) {
                    errors.emailConfirmation = "Requerido";
                } else if (!isValidEmail(confirmTrim)) {
                    errors.emailConfirmation = "Email inválido";
                }

                if (!errors.email && !errors.emailConfirmation && emailTrim && confirmTrim
                    && isValidEmail(emailTrim) && isValidEmail(confirmTrim) && emailTrim !== confirmTrim) {
                    errors.emailConfirmation = "No coincide";
                }

                if (Object.keys(errors).length) {
                    this.$store.dispatch("person/setValidationErrors", errors);
                    const messages = {
                        name: "Completá tu nombre.",
                        lastName: "Completá tu apellido.",
                        phone: "Completá tu celular.",
                        email: errors.email === "Email inválido"
                            ? "Ingresá un email válido (ej.: nombre@correo.com)."
                            : "Completá tu email.",
                        emailConfirmation: errors.emailConfirmation === "Email inválido"
                            ? "Ingresá una confirmación con formato de email válido."
                            : errors.emailConfirmation === "No coincide"
                                ? "El email y la confirmación no coinciden."
                                : "Completá la confirmación de email."
                    };
                    const firstField = Object.keys(errors)[0];
                    throw messages[firstField];
                }
                this.$store.dispatch("person/clearAllFieldErrors");
            },
            async getPdfPageCount(file) {
                    try {
                        if(this.optionPrint === 'IG' || file.type == 'application/pdf'){
                            
                        const reader = new FileReader();
                        return new Promise((resolve, reject) => {
                            reader.onload = async function () {
                                const arrayBuffer = reader.result;
                                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                                resolve(pdf.numPages); 
                            };
                            reader.onerror = (error) => reject(error);
                            reader.readAsArrayBuffer(file);
                        });
                    }else{
                        return 1;
                    }
                    } catch (error) {
                        throw(error);
                    }
            },
            getFileExtension(file) {
                const fileName = file.name;
                const extension = fileName.split('.').pop();
                return extension;
            },
            async uploadFileS3(file) {
                const tempId = `${Date.now()}_${Math.random()}`;
                const uploadEntry = { tempId, name: file.name, progress: 0 };
                this.uploadingFiles.push(uploadEntry);

                try {
                    this.validationFile(file);
                    const nameKey = `${Math.floor(Math.random() * 10001)}_${Date.now()}_${Math.floor(Math.random() * 10001)}.${this.getFileExtension(file)}`;
                    const pageCount = await this.getPdfPageCount(file);
    
                    const s3 = new S3({
                        endpoint: new AWS.Endpoint(process.env.VUE_APP_API_AWS_ENDPOINT),
                        accessKeyId: process.env.VUE_APP_API_AWS_ACCESS_KEY_ID,
                        secretAccessKey:process.env.VUE_APP_API_AWS_SECRET_ACCESS_KEY,
                        region: 'auto',
                        signatureVersion: 'v4',
                        httpOptions: { timeout: 600000 }
                    });
                    let ContentType = "";
                    if(this.optionPrint === 'IG'){
                        ContentType = "application/pdf";
                    }else{
                        ContentType = "application/pdf","image/jpeg","image/png";
                    }

                    const params = {
                        Bucket: "tiototo",
                        Key: nameKey,
                        Body: file,
                        ContentType: ContentType,
                        ACL:"private",
                    };
    
                    const upload = s3.upload(params, {
                        partSize: 5 * 1024 * 1024,
                        queueSize: 5
                    });
    
                    upload.on("httpUploadProgress", (progress) => {
                        const percentage = Math.round((progress.loaded / progress.total) * 100);
                        const entry = this.uploadingFiles.find(f => f.tempId === tempId);
                        if (entry) entry.progress = percentage;
                    });
    
                    await upload.promise();

                    // S3 done → mark 100%, now waiting for cotización
                    const entry = this.uploadingFiles.find(f => f.tempId === tempId);
                    if (entry) entry.progress = 100;

                    await this.getPriceByFile(file, nameKey, pageCount, tempId);
                } catch (error) {
                    this.uploadingFiles = this.uploadingFiles.filter(f => f.tempId !== tempId);
                    console.error("Error upload:", error);
                    this.$swal("Tío Toto", `Error al subir el archivo: ${error.message == null? error : error.message}`, "error");
                }
            },
            validationFile(file) {
                const maxSize = 400 * 1024 * 1024;
                if (file && file.size > maxSize) {
                    throw ('El tamaño del archivo excede el límite permitido de 400 MB.');
                }
                
                if(file && this.optionPrint === 'IG' && file.type != "application/pdf"){
                    throw ('El tipo de archivo permitido es PDF.');
                }
                if(file && this.optionPrint === 'F' && file.type != "application/pdf" && file.type != "image/jpeg" && file.type != "image/png"){
                    throw ('El tipo de archivo permitido es PDF,JPG,JPGE,PNG.');
                }
                
            },
            getPriceByFile: async function (file, nameKey, pageCount, tempId = null) {
                try {
                    const formData = new FormData();
                    formData.append('data', this.generateDataCotizacion(file, nameKey,pageCount));
                    const {
                        status,
                        data
                    } = await tioTotoService.getCotizacionByFile(formData);
                    file.id = new Date().getTime();
                    file.pages = data.pages;
                    file.price = data.price;
                    file.nameKey = data.nameKey;
                    this.pdfSrc.push(file);
                } catch (error) {
                    if (error != null && error.code != null && error.code == "ERR_NETWORK") {
                        this.$swal("Tío Toto", "No fue posible subir su archivo. Intentelo nuevamente", "info");
                    } else {
                        this.$swal("Tío Toto", error , "info");
                    }
                } finally {
                    if (tempId) {
                        this.uploadingFiles = this.uploadingFiles.filter(f => f.tempId !== tempId);
                    }
                    this.clearInputFile();
                }
            },
            addtoOrder: async function () {
                try {
                    if ( (this.optionPrint === 'F' && this.pdfSrc.length != 0 && this.hoja.length > 1 && this.cantidad > 0 && this.formato.length > 1 && this.calidad.length > 1 && this.margen.length > 1 && this.tipoPapel.length > 1)
                        ||
                        (this.optionPrint === 'IG' && this.pdfSrc.length != 0 && this.hoja.length > 1 && this.cantidad > 0 && this.formato.length > 1 && this.calidad.length > 1 && this.faz.length > 1 && this.tipoPapel.length > 1 && this.terminado.length > 1)) {
                        store.dispatch("setSpinner", true);
                        var obj = new Object();
                        var tapaAgrupada = 0;
                        obj.terminado = this.terminado;
                        obj.cantidad = this.cantidad;
                        obj.agrupado = this.agrupado;
                        obj.formato = this.formato;
                        obj.faz = this.faz;
                        obj.data = JSON.stringify(this.pdfSrc);
                        obj.tapa = this.tapa;
                        const {
                            status,
                            data
                        } = await tioTotoService.getTerminadoAgrupado(JSON.stringify(obj));
                        this.order.push(this.generateDtoOrder(data));
                        this.pdfSrc = [];
                    } else {
                        this.$swal("Tío Toto", "Cotice al menos un archivo para agregarlo al pedido.", "info");
                    }
                } catch (error) {
                    this.$swal("Tío Toto", "Se ha generado un error al agregar los archivos al carrito", "info");
                } finally {
                    store.dispatch("setSpinner", false);
                }
            },
    
            removeFileCotizacion: async function (dataFile) {
                store.dispatch("setSpinner", true);
                await tioTotoService.removeFileCotizacion(JSON.stringify(dataFile));
                this.pdfSrc = this.pdfSrc.filter(item => item.id !== dataFile.id);
                store.dispatch("setSpinner", false);
            },
    
            // ****************************** FUNCTION UTILS *************************************
    
            uploadFile() {
                $("#fileInput").click();
            },
            generateDtoOrder(data) {
                var obj = new Object();
                obj.files = this.pdfSrc;
                obj.tamHojas = this.hoja;
                obj.tamHojasDesc = this.hojaDesc;
                obj.formato = this.formato;
                obj.formatoDesc = this.formatoDesc;
                obj.calidad = this.calidad;
                obj.calidadDesc = this.calidadDesc;
                obj.faz = this.faz;
                obj.fazDesc = this.fazDesc;
                obj.terminado = this.terminado;
                obj.terminadoDesc = this.terminadoDesc;
                obj.tipoPapel = this.tipoPapel;
                obj.tipoPapelDesc = this.tipoPapelDesc;
                obj.agrupado = this.agrupado;
                obj.agrupadoDesc = this.agrupadoDesc;
                obj.cantidad = this.cantidad;
                obj.id = this.idPerson;
                obj.idOrder = new Date().getTime();
                obj.totalTerminado = data.terminado;
                obj.selectedOption = this.optionPrint;
                obj.margen = this.margen;
                obj.margenDesc = this.margenDesc;
                obj.tapa = this.tapa;
                obj.tapaDesc = this.tapaDesc;
                obj.tapaAgrupada = data.tapa;
                return obj;
            },
            totalOrder() {
                let sum = 0;
                this.order.forEach(data => {
                    Array.from(data.files).forEach(files => {
                        sum = sum + files.price * data.cantidad;
                    })
                    sum = sum + data.totalTerminado + data.tapaAgrupada;
                })
                return this.formatearMoneda(sum);
            },
            totalSubOrder() {
                let sum = 0;
                this.pdfSrc.forEach(data => {
                    sum = sum + data.price * this.cantidad;
                })
                return this.formatearMoneda(sum);
            },
            createPDF(data) {
                return URL.createObjectURL(data);
            },
    
            removeOrder(idOrder) {
                this.order = this.order.filter(item => item.idOrder !== idOrder);
                if (this.order.length == 0) {
                    setTimeout(() => {
                        jQuery("#modalOrder").modal("toggle");
                    }, 100);
                }
            },
            previewPdf(data) {
                this.pdfPreview = data;
                this.isVisible = true;
                setTimeout(() => {
                    jQuery("#modalPdfPreview").modal("toggle");
                }, 100);
            },
            previewOrder() {
                try {
                    this.validationDataUser();
                } catch (e) {
                    this.$swal("Tío Toto", e, "info");
                    return;
                }
                if (this.order.length == 0) {
                    this.$swal("Tío Toto", "Necesitás agregar una orden para continuar con el pago.", "info");
                } else {
                    this.isVisibleOrder = true;
                    setTimeout(() => {
                        jQuery("#modalOrder").modal("toggle");
                    }, 100);
                }
            },
            clearInputFile() {
                const fileInput = this.$refs.fileInput;
                fileInput.value = '';
            },
            generateDataCotizacion(file, nameKey,pageCount) {
                
                let obj = new Object();
                obj.tamHojas = this.hoja;
                obj.tamHojasDesc = this.hojaDesc;
                obj.formato = this.formato;
                obj.formatoDesc = this.formatoDesc;
                obj.calidad = this.calidad;
                obj.calidadDesc = this.calidadDesc;
                obj.faz = this.faz;
                obj.fazDesc = this.fazDesc;
                obj.terminado = this.terminado;
                obj.terminadoDesc = this.terminadoDesc;
                obj.tipoPapel = this.tipoPapel;
                obj.tipoPapelDesc = this.tipoPapelDesc;
                obj.agrupado = this.agrupado;
                obj.agrupadoDesc = this.agrupadoDesc;
                obj.cantidad = 1;
                obj.fileExtension = file.name;
                obj.userID = this.idPerson;
                obj.nameKey = nameKey == null || nameKey == '' ? file.nameKey : nameKey;
                obj.fileName = file.name;
                obj.margen = this.margen;
                obj.margenDesc = this.margenDesc;
                obj.selectedOption = this.optionPrint;
                obj.page = pageCount;
                obj.tapa = this.tapa;
                obj.tapaDesc = this.tapaDesc;
                return JSON.stringify(obj)
            },
            formatearMoneda(value) {
                let val = (value / 1).toFixed(0).replace(".", ",");
                return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
            validatePdfReload() {
                if(this.optionPrint === 'IG'){
                    if (
                        this.hoja.length > 1 &&
                        this.cantidad > 0 &&
                        this.formato.length > 1 &&
                        this.calidad.length > 1 &&
                        this.faz.length > 1 &&
                        this.tipoPapel.length > 1 &&
                        this.terminado.length > 1 &&
                        !(this.terminado === "TRH02" && this.agrupado === "") &&
                        this.hoja !== null &&
                        this.cantidad !== null &&
                        this.formato !== null &&
                        this.calidad !== null &&
                        this.faz !== null &&
                        this.tipoPapel !== null &&
                        this.terminado !== null &&
                        this.agrupado !== null
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                }else{
                    if (
                        this.hoja.length > 1 &&
                        this.cantidad > 0 &&
                        this.formato.length > 1 &&
                        this.calidad.length > 1 &&
                        this.tipoPapel.length > 1 &&
                        this.margen.length > 1 &&
                        this.hoja !== null &&
                        this.cantidad !== null &&
                        this.formato !== null &&
                        this.calidad !== null &&
                        this.tipoPapel !== null &&
                        this.margen !== null
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                }
               
            },
            async reloadPricePDF() {
                if (this.validatePdfReload()) {
                    let data = this.pdfSrc;
                    this.pdfSrc = [];
                    
                    for (const file of data) {
                        const pageCount = await this.getPdfPageCount(file);
                        this.getPriceByFile(file, "", pageCount);
                    }
                }
            }
        },
        watch: {
            hoja() {
                this.reloadPricePDF();
            },
            fomato() {
                this.reloadPricePDF();
            },
            calidad() {
                this.reloadPricePDF();
            },
            faz() {
                this.reloadPricePDF();
            },
            tipoPapel() {
                this.reloadPricePDF();
            },
            terminado() {
                this.reloadPricePDF();
            },
            agrupado() {
                this.reloadPricePDF();
            },
        },
        computed: {
            hoja: {
                get() {
                    return this.$store.state.dataOrder.send.hojas;
                },
            },
            hojaDesc: {
                get() {
                    return this.$store.state.dataOrder.send.hojasDesc;
                },
            },
            formato: {
                get() {
                    return this.$store.state.dataOrder.send.formato;
                },
            },
            formatoDesc: {
                get() {
                    return this.$store.state.dataOrder.send.formatoDesc;
                },
            },
            calidad: {
                get() {
                    return this.$store.state.dataOrder.send.calidad;
                },
            },
            calidadDesc: {
                get() {
                    return this.$store.state.dataOrder.send.calidadDesc;
                },
            },
            faz: {
                get() {
                    return this.$store.state.dataOrder.send.faz;
                },
            },
            fazDesc: {
                get() {
                    return this.$store.state.dataOrder.send.fazDesc;
                },
            },
            tipoPapel: {
                get() {
                    return this.$store.state.dataOrder.send.tipoPapel;
                },
            },
            tipoPapelDesc: {
                get() {
                    return this.$store.state.dataOrder.send.tipoPapelDesc;
                },
            },
            terminado: {
                get() {
                    return this.$store.state.dataOrder.send.terminado;
                },
            },
            terminadoDesc: {
                get() {
                    return this.$store.state.dataOrder.send.terminadoDesc;
                },
            },
            optionPrint: {
                get() {
                    return this.$store.state.dataOrder.send.optionPrint;
                },
            },
            margen: {
                get() {
                    return this.$store.state.dataOrder.send.margen;
                },
            },
            agrupado: {
                get() {
                    return this.$store.state.dataOrder.send.agrupado;
                },
            },
            agrupadoDesc: {
                get() {
                    return this.$store.state.dataOrder.send.agrupadoDesc;
                },
            },
            portada: {
                get() {
                    return this.$store.state.dataOrder.send.portada;
                },
            },
            cantidad: {
                get() {
                    return this.$store.state.dataOrder.send.cantidad;
                },
            },
            name: {
                get() {
                    return this.$store.state.person.name;
                }
            },
            lastName: {
                get() {
                    return this.$store.state.person.lastName;
                }
            },
            phone: {
                get() {
                    return this.$store.state.person.phone;
                }
            },
            email: {
                get() {
                    return this.$store.state.person.email;
                }
            },
            emailConfirmation: {
                get() {
                    return this.$store.state.person.emailConfirmation;
                }
            },
            idPerson: {
                get() {
                    return this.$store.state.person.id;
                }
            },
            tapa: {
                get() {
                    return this.$store.state.dataOrder.send.tapa;
                },
            },
            tapaDesc: {
                get() {
                    return this.$store.state.dataOrder.send.tapaDesc;
                },
            },
        }
    };
    </script>
    
    <style>
    .page {
        height: auto !important;
        width: auto !important;
    }
    
    .pdf-container {
        display: flex;
        margin-left: auto;
        margin-right: auto;
    }
    
    .pdf-page {
        flex: 1;
        max-width: 60%;
    }
    
    .pdf-page-vertical {
        flex: 1;
        max-width: 28%;
    }
    
    .container-pdf {
        margin: auto;
    }
    
    .pdf-height {
        min-height: 330px !important;
    }
    </style>
    